import { IChoiceStep } from '../types';

import {
    ChoiceDisplay,
    ChoiceDisplayInstruction,
} from '../components/ChoiceDisplay';

import { colors } from '../constants';

import { BaseAstigmatismLines } from '../svg';

export const astigmatismTestSteps: IChoiceStep[] = [
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>linkeroog</strong> met je hand.',
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question: 'Zien alle lijnen er hetzelfde uit?',
            svgComponent: BaseAstigmatismLines,
        },
    },
    {
        component: ChoiceDisplayInstruction,
        bgColor: colors.greenBg,
        props: {
            headerText: 'Bedek je <strong>rechteroog</strong> met je hand.',
        },
    },
    {
        component: ChoiceDisplay,
        bgColor: colors.white,
        props: {
            question: 'Zien alle lijnen er hetzelfde uit?',
            svgComponent: BaseAstigmatismLines,
        },
    },
];
